/**
 * Single runtime accessor for the application version.
 *
 * The value originates from the `VERSION` file at the repository root — the
 * same file the backend reads — and is injected at build time by `define` in
 * vite.config.ts. No other module, and in particular no piece of markup, may
 * embed a version literal.
 */
export const APP_VERSION: string = __APP_VERSION__;

/** Display form used by the shell, e.g. `v0.1.0`. */
export const APP_VERSION_LABEL = `v${APP_VERSION}`;
